import { HeroSection } from '@/components/sections/HeroSection'
import { ValuePropositionSection } from '@/components/sections/ValuePropositionSection'
import { ProblemSolutionSection } from '@/components/sections/ProblemSolutionSection'
import { ProjectsSection } from '@/components/sections/ProjectsSection'
import { PartnersSection } from '@/components/sections/PartnersSection'
import { TechnologySection } from '@/components/sections/TechnologySection'
import { IndustriesSection } from '@/components/sections/IndustriesSection'
import { FinalCTASection } from '@/components/sections/FinalCTASection'

export function HomePage(): HTMLElement {
  // Main content container
  const main = document.createElement('div')
  main.className = 'pt-20'

  // Add all sections
  main.appendChild(HeroSection())
  main.appendChild(ValuePropositionSection())
  main.appendChild(ProblemSolutionSection())
  main.appendChild(ProjectsSection())
  main.appendChild(TechnologySection())
  main.appendChild(IndustriesSection())
  main.appendChild(PartnersSection())
  main.appendChild(FinalCTASection())

  return main
}
